import { render, staticRenderFns } from "./BaseIconButton.vue?vue&type=template&id=702ac08c&scoped=true&"
import script from "./BaseIconButton.vue?vue&type=script&lang=ts&"
export * from "./BaseIconButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseIconButton.vue?vue&type=style&index=0&id=702ac08c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702ac08c",
  null
  
)

export default component.exports